import React, { useState } from 'react';
import { Row, Col, Table, Button, Container } from 'reactstrap';
import { T } from '../traks';
import I18N from '../I18N';
import { Apify } from '../Apify';
import ChangeArrow from '../c/ChangeArrow';
import { default_currency } from '../Site';

const PAGE_SIZE = 50;

const PaginatedGroupLeaderboardResource = Apify("/z/paginated_group_leaderboard", {})
    .with_query_from_props(({ groupId, page }) => ({
        group_id: groupId,
        offset: page * PAGE_SIZE,
        limit: PAGE_SIZE,
    }))
    .with_props_from_response(data => ({
        portfolios: (data && data.Portfolios) ? data.Portfolios : [],
        pageMeta: data || null,
        totalPlayers: (data && data.PlayerCount) ? data.PlayerCount : 0,
    }));

function deltaMoney(v, init) { return v - init; }
function deltaPct(v, init) { return init ? ((v / init) - 1) * 100 : 0; }

export default function GroupLeaderboardPaginated(props) {
    const [page, setPage] = useState(0);

    const groupId = props.group_id;
    if (!groupId || Number.isNaN(groupId)) {
        return <div className="text-danger"><T>Missing group id</T></div>;
    }

    const Body = PaginatedGroupLeaderboardResource.wrap(({ portfolios, pageMeta, totalPlayers, loading, error }) => {
        if (loading) return <div>Loading...</div>;
        if (error)   return <div className="text-danger">Error: {error.message || String(error)}</div>;
        if (!pageMeta) return null;

        const totalPages = Math.max(1, Math.ceil(totalPlayers / PAGE_SIZE));

        return (
            <Container className="py-3">
                <Row className="ad_game_box">
                    <Col xs="12" className="py-3">
                        <div className="pb-0 ad_150pct mr-auto">
                            <span className="fw-bold"><T>Pool</T></span> — {pageMeta.Name}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs="12">
                        <Table className="ad_leader_board bg-color-white">
                            <thead>
                                <tr>
                                    <th className="ad_th_1px" />
                                    <th><span className="ad_game_table_header font-s pl-3"><T>NAME</T></span></th>
                                    <th className="d-none d-sm-table-cell"><span className="ad_game_table_header font-s"><T>TRADES</T></span></th>
                                    <th className="d-none d-sm-table-cell"><span className="ad_game_table_header font-s"><T>TOTAL CHANGE</T></span></th>
                                    <th className="text-end"><span className="ad_game_table_header font-s"><T>VALUE</T></span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {portfolios.map((p, i) => {
                                    const dm = deltaMoney(p.Value, pageMeta.InitialAmount);
                                    const dp = deltaPct(p.Value, pageMeta.InitialAmount);
                                    const suffix = <span> ({I18N.floatval(dp, 2)}%)</span>;
                                    const row = "ad_game_table_border ad_grey_hover";
                                    const place = page * PAGE_SIZE + i + 1;

                                    return (
                                        <tr
                                            className={`${row} ad_leaderboard_entry`}
                                            key={p.Id}
                                            onClick={() => window.location.href = `/portfolio/${p.Id}`}
                                            tabIndex={0}
                                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') window.location.href = `/portfolio/${p.Id}`; }}
                                            role="button"
                                            aria-label={`Go to portfolio for ${p.OwnerScreenName}`}
                                        >
                                            <td className="text-right fw-bold">{place}</td>
                                            <td className="pl-4 mr-0 align-middle table-cell-min py-md-2 fw-bold">
                                                <span className="text-overflow-dynamic-container">
                                                    <span className="text-overflow-dynamic-ellipsis">{p.OwnerScreenName}</span>
                                                </span>
                                            </td>
                                            <td className="d-none d-sm-table-cell fw-bold txt-color-dark-black"><span>{p.TradesCount}</span></td>
                                            <td className="d-none d-sm-table-cell fw-bold"><ChangeArrow currency_unit={default_currency} pct={dm} suffix={suffix} /></td>
                                            <td className="text-end fw-bold"><span>{I18N.floatval_unit(p.Value, 2, default_currency)}</span></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>

                        <div className="d-flex justify-content-between my-3">
                            <Button
                                className="xyzzy_button btn btn-outline-light"
                                disabled={page === 0}
                                onClick={() => setPage(p => p - 1)}
                            >
                                Forrige
                            </Button>
                            <div>Side {page + 1} af {totalPages}</div>
                            <Button
                                className="xyzzy_button btn btn-outline-light"
                                disabled={page + 1 >= totalPages}
                                onClick={() => setPage(p => p + 1)}
                            >
                                <T>Next</T>
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    });

    return <Body groupId={groupId} page={page} />;
}


// WEBPACK FOOTER //
// ./src/p/FullGroupLeaderboard.js